import { html } from 'lit';

import { AIAnimatedIcon, animatedAIIcon } from './ai-animated-icon';

export const AIStarIcon = html`<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_7444_26654)">
    <path
      d="M9.40033 4.57585C9.36627 4.27519 9.11207 4.04792 8.80948 4.04761C8.50689 4.0473 8.25223 4.27405 8.21756 4.57465C7.99211 6.52928 7.40771 7.90373 6.46492 8.84651C5.52213 9.7893 4.14769 10.3737 2.19305 10.5991C1.89246 10.6338 1.66571 10.8885 1.66602 11.1911C1.66633 11.4937 1.8936 11.7479 2.19426 11.7819C4.11659 11.9997 5.52025 12.5838 6.48542 13.5315C7.44696 14.4757 8.04356 15.8498 8.21597 17.7908C8.24327 18.0981 8.50096 18.3337 8.80954 18.3333C9.11813 18.333 9.37528 18.0969 9.40189 17.7894C9.56714 15.8804 10.1632 14.4774 11.1295 13.5111C12.0958 12.5448 13.4988 11.9487 15.4078 11.7835C15.7153 11.7569 15.9514 11.4997 15.9517 11.1911C15.9521 10.8825 15.7165 10.6249 15.4092 10.5976C13.4683 10.4252 12.0941 9.82855 11.15 8.86701C10.2022 7.90184 9.61807 6.49818 9.40033 4.57585Z"
      fill="#1E96EB"
    />
    <path
      d="M15.7849 1.87208C15.7717 1.75516 15.6728 1.66678 15.5551 1.66666C15.4375 1.66654 15.3384 1.75472 15.3249 1.87162C15.2373 2.63175 15.01 3.16626 14.6434 3.5329C14.2767 3.89954 13.7422 4.1268 12.9821 4.21448C12.8652 4.22796 12.777 4.327 12.7771 4.44467C12.7772 4.56234 12.8656 4.6612 12.9826 4.67445C13.7301 4.75912 14.276 4.9863 14.6513 5.35485C15.0253 5.72203 15.2573 6.25642 15.3243 7.01121C15.335 7.13075 15.4352 7.22235 15.5552 7.22221C15.6752 7.22208 15.7752 7.13025 15.7855 7.01069C15.8498 6.26831 16.0816 5.72268 16.4574 5.3469C16.8332 4.97111 17.3788 4.73932 18.1212 4.67505C18.2407 4.6647 18.3325 4.5647 18.3327 4.44469C18.3328 4.32469 18.2412 4.22448 18.1217 4.21386C17.3669 4.14681 16.8325 3.9148 16.4653 3.54087C16.0968 3.16552 15.8696 2.61966 15.7849 1.87208Z"
      fill="#1E96EB"
    />
  </g>
  <defs>
    <clipPath id="clip0_7444_26654">
      <rect width="20" height="20" fill="white" />
    </clipPath>
  </defs>
</svg>`;

// Custom elements exist only in the browser.
if (typeof window !== 'undefined') {
  customElements.define('ai-animated-icon', AIAnimatedIcon);
}

export const AIStarIconWithAnimation = animatedAIIcon(AIStarIcon);

export const AIStopIcon = html`<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_7496_34464)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.0827 10C17.0827 13.912 13.9114 17.0834 9.99935 17.0834C6.08733 17.0834 2.91602 13.912 2.91602 10C2.91602 6.088 6.08733 2.91669 9.99935 2.91669C13.9114 2.91669 17.0827 6.088 17.0827 10ZM18.3327 10C18.3327 14.6024 14.6017 18.3334 9.99935 18.3334C5.39698 18.3334 1.66602 14.6024 1.66602 10C1.66602 5.39765 5.39698 1.66669 9.99935 1.66669C14.6017 1.66669 18.3327 5.39765 18.3327 10ZM8.33268 6.66669C7.41221 6.66669 6.66602 7.41288 6.66602 8.33335V11.6667C6.66602 12.5872 7.41221 13.3334 8.33268 13.3334H11.666C12.5865 13.3334 13.3327 12.5872 13.3327 11.6667V8.33335C13.3327 7.41288 12.5865 6.66669 11.666 6.66669H8.33268Z"
      fill="#1E96EB"
    />
  </g>
  <defs>
    <clipPath id="clip0_7496_34464">
      <rect width="20" height="20" fill="white" />
    </clipPath>
  </defs>
</svg>`;

export const AIDoneIcon = html`<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="currentColor"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M16.2751 5.39143C16.5192 5.63551 16.5192 6.03124 16.2751 6.27532L7.94178 14.6086C7.6977 14.8527 7.30197 14.8527 7.0579 14.6086L3.72456 11.2753C3.48048 11.0312 3.48048 10.6355 3.72456 10.3914C3.96864 10.1474 4.36437 10.1474 4.60845 10.3914L7.49984 13.2828L15.3912 5.39143C15.6353 5.14735 16.031 5.14735 16.2751 5.39143Z"
  />
</svg>`;

export const EnterIcon = html`<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="currentColor"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M11.2502 4.16663C11.2502 3.82145 11.53 3.54163 11.8752 3.54163H15.6252C15.9703 3.54163 16.2502 3.82145 16.2502 4.16663V11.25C16.2502 11.4157 16.1843 11.5747 16.0671 11.6919C15.9499 11.8091 15.7909 11.875 15.6252 11.875L5.45567 11.875L8.24903 14.6994C8.49175 14.9448 8.48957 15.3405 8.24414 15.5832C7.99872 15.826 7.603 15.8238 7.36027 15.5783L3.51412 11.6895C3.27329 11.4459 3.27329 11.054 3.51412 10.8105L7.36027 6.92158C7.603 6.67615 7.99872 6.67397 8.24414 6.91669C8.48957 7.15942 8.49175 7.55514 8.24903 7.80056L5.45567 10.625L15.0002 10.625V4.79163H11.8752C11.53 4.79163 11.2502 4.5118 11.2502 4.16663Z"
  />
</svg> `;

export const ArrowRightIcon = html`<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="currentColor"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7.05838 5.39143C6.81431 5.63551 6.81431 6.03124 7.05838 6.27532L10.7831 10L7.05838 13.7248C6.81431 13.9688 6.81431 14.3646 7.05838 14.6087C7.30246 14.8527 7.69819 14.8527 7.94227 14.6087L12.1089 10.442C12.353 10.1979 12.353 9.80218 12.1089 9.5581L7.94227 5.39143C7.69819 5.14735 7.30246 5.14735 7.05838 5.39143Z"
  />
</svg> `;
